import { render, staticRenderFns } from "./DeFarendeSvende.vue?vue&type=template&id=66ad3778&"
import script from "./DeFarendeSvende.vue?vue&type=script&lang=js&"
export * from "./DeFarendeSvende.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports